let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hlxM5")).then(() => parcelRequire('3u5Rs'));